A short status describing why the position was not posted on SEEK.

For example, "Couldn't post".
